import axios from "axios";
const uri = "https://www.lefisc.com.br/api/monitoramentoNCM/Cliente";
const tok = "64ad62a25fe48a9e8bcd84df737dd40b";
const uriBusca = "BuscaDescricao";


export default {
  async getResultados(descricaoNCM) {
    return await axios
      .get(`${uri}/${uriBusca}/${descricaoNCM}/${tok}`)
      .then(res => {
        return res.data;
      }, err => {
        return err.response;
      })
      .catch(err => { return err });
  }
}